import Box from '@totallymoney/ui/components/Box'
import { Field } from 'formik'
import * as React from 'react'

import useWindowSize from '@hooks/useWindowSize'

import FormikRadioGroup from '@components/form/FormikRadioGroup'
import FormikSelectField from '@components/form/FormikSelectField'

interface LoanPurposeSelect {
    name: string
    labelText: string
    options: { label: string; value: string }[]
}

const LoanPurposeSelect = ({ name, labelText, options }: LoanPurposeSelect) => {
    const { width } = useWindowSize()

    return (
        <Box>
            {width! > 768 ? (
                <Field
                    component={FormikSelectField}
                    labelText={labelText}
                    name={name}
                    options={options}
                />
            ) : (
                <Field
                    component={FormikRadioGroup}
                    labelText={labelText}
                    name={name}
                    options={options}
                    variant="list"
                />
            )}
        </Box>
    )
}

export default LoanPurposeSelect
